import React, {useMemo} from "react";
import {Button, Modal, Stack} from "rsuite";

const UserAckModal = (props) => {
    const { handleClose, open, systemMessageBlurb } = props;

    return useMemo(() => {
        return (
            <Modal
                backdrop="static"
                role="alertdialog"
                open={open}
                onClose={handleClose}
                keyboard={false}
                size="sm"
            >
                <Modal.Body>
                    <Stack spacing={20} direction='column' alignItems='flex-start'>
                        <h2>System Use Acknowledgement</h2>
                        <p>Welcome to the Synergist Resume Manager!</p>
                        In order to use this system, please acknowledge system use requirements: <b>{systemMessageBlurb} </b>
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} appearance="primary">
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
        );
        }, [handleClose, open, systemMessageBlurb]
    );
};

export default UserAckModal;